// extracted by mini-css-extract-plugin
export default {"wrapper":"cart-breakdown_wrapper__krb7i","items":"cart-breakdown_items__h2tIa"};